import { IAngularEvent, IComponentController } from 'angular';
import { OPENTYPE_FEATURES } from '../../../tn.common/constants/OPENTYPE_FEATURES';
import glyphCaseTreeTemplate from './glyph-case-tree.html';

const caseSortOrder = [
    'caseless',
    'uppercase',
    'lowercase',
    'small_caps',
    'multicase',
    'other',
];

const innerSortOrder = [
    'default',
    'uppercase',
    'small_caps',
    'stylistic_alternates',
    // emits stylistic_set_0-stylistic_set_21
    ...Array.apply(0, Array(21)).map((x, y) => 'stylistic_set_' + y),
    'ornaments',
    'swashes',
    'ligatures',
    'superscript',
    'subscript',
];
const otFeatureSortOrder = [
    'normal',
    ...Object.keys(OPENTYPE_FEATURES)
        .sort()
        .map((k) => `"${k}"`),
];


interface OnGlyphClickedArgs {
    $event: IAngularEvent;
    glyph: string;
    otFeature: string;
}

class TnGlyphsCaseTreeComponentBindings {
    name?: string;
    nodes = [];
    fontCss = 'font-family: "Adobe Blank";';
    onExpandoClicked?: ({ $event: IAngularEvent }) => void;
    onGlyphClicked?: (args: OnGlyphClickedArgs) => void;
}


interface OTFeatureSection {
    label: string
    css: string
}

interface AlternateSection  {
    label: string
    children: OTFeatureSection[]
}

interface CaseSection  {
    label: string;
    children: AlternateSection[]
}

class TnGlyphsCaseTreeComponent extends TnGlyphsCaseTreeComponentBindings implements IComponentController  {
    tree: CaseSection[] = [];
    caseSortOrder = caseSortOrder;
    innerSortOrder = innerSortOrder;
    otFeatureSortOrder = otFeatureSortOrder;

    constructor() {
        super();
    }

    populateTree(): void {
        // console.log('populatTree');
        // caseSortOrder.map(case => {
        //     console.log('case', case)
        //     return {}
        // });

    }

    glyphClicked($event: IAngularEvent, glyph: string, otFeature: string): void {
        this.onGlyphClicked && this.onGlyphClicked({ $event, glyph, otFeature });
    }

    expandoClicked($event: IAngularEvent): void {
        this.onExpandoClicked && this.onExpandoClicked({ $event });
    }
}

export const TnGlyphCaseTreeComponentOptions = {
    bindings: {
        name: '<',
        nodes: '<',
        fontCss: '<',
        onExpandoClicked: '&?',
        onGlyphClicked: '&?',
    },
    template: glyphCaseTreeTemplate,
    controller: TnGlyphsCaseTreeComponent,
};



